import {UserUtil} from '../utils/UserUtil';
import {Validator} from '../utils/Validator';
import {Scheduler} from '../utils/Scheduler';
import {HttpClient} from '@angular/common/http';
import {Toaster, Type} from '../toaster/Toaster';
import {MatDialog} from '@angular/material/dialog';
import {UserService} from '../service/user.service';
import {Step} from '../application-flow/steps/step';
import {UserNavigator} from '../utils/UserNavigator';
import {ActivatedRoute, Router} from '@angular/router';
import {AdvanceEmiPlan} from '../model/AdvanceEmiPlan';
import {TermsComponent} from '../terms/terms.component';
import {ApiServiceService} from '../api-service.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {ReferralService} from '../service/referral.service';
import {UserInteractor} from '../interactors/user.interactor';
import {Keys, StorageService} from '../service/storage.service';
import {LoanApplication} from '../model/loan-application.model';
import {Component, OnInit, Type as Constructor} from '@angular/core';
import {ChannelPartnerService} from '../service/channel-partner.service';
import {LoanApplicationService} from '../service/loan-application.service';
import {UnprocessableEntityError} from '../errors/UnprocessableEntityError';
import {EligibilityCheckService} from '../service/eligibility-check.service';
import {BasePhoneVerificationComponent} from './base-phone-verification.component';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {PhoneVerificationStep} from '../application-flow/steps/phone-verification.step';
import {LoanApplicationFlowNavigator} from '../application-flow/loan-application-flow.navigator';
import {SharedEligibilityCheckForm} from '../borrow/eligibility-check/eligibility-check-form/eligibility-check-form.component';
import {ConfigService} from '../service/config.service';
import {ConsentService} from '../service/consent.service';
import {ConsentAudit, ConsentType} from '../model/ConsentAudit';

@Component({
    selector: 'app-phoneverification',
    templateUrl: './phoneverification.component.html',
    styleUrls: ['../../assets/styles/finzy-styles.scss', './phoneverification.component.css', '../loan-application-flow-component/application-flow.css'],
    providers: [ApiServiceService, ReferralService, ChannelPartnerService, EligibilityCheckService]
})
export class PhoneVerificationComponent extends BasePhoneVerificationComponent implements OnInit {

    otp: string;
    loader = false;
    disableBtn = true;
    otpDisabled = false;
    phoneNumberDisabled = false;
    consentForEquifaxCheck = false;
    termsAndConditionsCheck = false;
    borrowedAmountDeclarationCheck = false;
    userConsents: ConsentAudit[];
    private dialog: MatDialog;
    private userNavigator: UserNavigator;
    private userUtil: UserUtil;
    private readonly userInteractor: UserInteractor;
    private channelPartnerService: ChannelPartnerService;
    private readonly loanApplicationService: LoanApplicationService;
    private readonly loanApplicationInteractor: LoanApplicationInteractor;
    private readonly eligibilityCheckService: EligibilityCheckService;
    private readonly consentService: ConsentService;
    private readonly configService: ConfigService;

    constructor(dialog: MatDialog, http: HttpClient, ref: ApiServiceService, router: Router, storageService: StorageService,
                validator: Validator, scheduler: Scheduler, userNavigator: UserNavigator, userUtil: UserUtil,
                userService: UserService, activatedRoute: ActivatedRoute, public analyticsTracker: AnalyticsTracker,
                channelPartnerService: ChannelPartnerService, loanApplicationService: LoanApplicationService,
                applicationFlowNavigator: LoanApplicationFlowNavigator, loanApplicationInteractor: LoanApplicationInteractor,
                userInteractor: UserInteractor, eligibilityCheckService: EligibilityCheckService, consentService: ConsentService,
                configService: ConfigService) {
        super(http, validator, ref, storageService, scheduler, userService, router, activatedRoute, analyticsTracker, applicationFlowNavigator);
        this.dialog = dialog;
        this.userUtil = userUtil;
        this.userNavigator = userNavigator;
        this.userInteractor = userInteractor;
        this.channelPartnerService = channelPartnerService;
        this.loanApplicationService = loanApplicationService;
        this.eligibilityCheckService = eligibilityCheckService;
        this.loanApplicationInteractor = loanApplicationInteractor;
        this.consentService = consentService;
        this.configService = configService;
    }

    async ngOnInit() {
        await this.getAndSetConsentStates();

        if (this.storageService.getItem(Keys.IS_OTP_VERIFIED) === 'true' && this.storageService.getItem(Keys.PAN_VERIFIED) == 'true') {
            this.http.post(this.ref.baseURL() + 'getProfileDetails', {
                profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                token: this.storageService.getItem(Keys.TOKEN)
            })
                .subscribe((result2: any) => {
                    if (result2.status === 'Success') {
                        this.phoneNumber = result2.mobile_no;
                        this.fieldDisabledTag = true;
                        this.phoneNumberDisabled = true;
                    }
                });
        } else if (this.storageService.getItem(Keys.PAN_VERIFIED) == 'true') {
            this.fieldDisabledTag = false;
            this.phoneNumberDisabled = false;
            this.otpDisabled = false;
        }
    }

    openDialog() {
        this.dialog.open(TermsComponent, {height: '500px', width: '600px'});
    }

    onPhoneInput(event) {
        this.mobileError = false;
        this.phoneNumber = event.target.value.replace(/[^0-9]+/, '');
        if (event.target.value.length === 10) {
            if (event.target.value.match(/[6789][0-9]{9}/)) {

            } else {
                this.mobileError = true;
                this.mobileErrorMsg = 'Please provide a valid mobile number';
                return false;
            }
        }
    }

    // TODO: Should be refactored
    async submitOtpVerification(formData): Promise<boolean> {
        this.disableBtn = false;
        this.loader = true;
        if (this.userUtil.isUserLoggedIn()) {
            if (!(this.isLoanAssociated())) {
                if (!this.areTermsChecked(formData)) {
                    this.loader = false;
                    this.disableBtn = true;
                    this.checkError = true;
                    return false;
                }
                if (this.configService.isMultipleLoanApplyEnabled()) {
                    const profileId = this.storageService.getItem(Keys.PROFILE_ID);
                    const loanApplications = await this.loanApplicationInteractor.getByUserId(profileId);
                    if (loanApplications.length > 0 && !await this.loanApplicationInteractor.canReapplyForLoan(profileId)) {
                        Toaster.toast(`Sorry, cannot apply for loan.`, Type.Error);
                        this.loader = false;
                        return false;
                    }
                }
                const createdLoan = await this.createLoanApplicationAndSaveConsents();
                const selectedOptionId = this.storageService.getItem(Keys.SELECTED_CREDIT_OPTION_ID);
                if (selectedOptionId) {
                    const selectedOption = await this.eligibilityCheckService.getSelectedCreditOption(selectedOptionId);
                    selectedOption.associateLoanApplication(createdLoan.id);
                    await this.eligibilityCheckService.updateSelectedCreditOption(selectedOptionId, selectedOption);
                }
            }
            this.navigateToNextStep();
            return true;
        }

        if (this.userUtil.isUserRegistered()) {
            if (!(this.isLoanAssociated())) {
                if (!this.areTermsChecked(formData)) {
                    this.loader = false;
                    this.disableBtn = true;
                    this.checkError = true;
                    return false;
                }
                await this.createLoanApplicationAndSaveConsents();
            }
            this.navigateToNextStep();
            return true;
        }

        if (!this.areTermsChecked(formData)) {
            this.loader = false;
            this.disableBtn = true;
            this.checkError = true;
            return false;
        }
        this.checkError = false;
        this.mobileOtpError = false;
        this.mobileError = false;

        if (this.storageService.getItem(Keys.IS_OTP_VERIFIED) == 'true') {
            this.loader = false;
            this.disableBtn = true;
            this.navigateToNextStep();
            return true;
        } else if (!(this.sendOtpButtonEvent === true && formData.otp)) {
            this.loader = false;
            this.disableBtn = true;
            this.mobileError = true;
            this.mobileErrorMsg = 'Click on SEND OTP to continue';
            return false;
        }

        await this.verifyOtpAndCreateUser(formData.otp);
    }

    async onUserCreatedSuccessfully(): Promise<void> {
        await this.createLoanApplicationAndSaveConsents();
        await this.navigateToNextStep();
    }

    async onPhoneVerificationFailed(error: any): Promise<void> {
        this.loader = false;
        this.disableBtn = true;
        if (error instanceof UnprocessableEntityError) {
            this.mobileOtpError = true;
        } else {
            Toaster.toast(`Something went wrong. Please try again later.`, Type.Error);
        }
    }

    async onUserCreationFailed(): Promise<void> {
        this.loader = false;
        this.disableBtn = true;
        this.mobileOtpError = false;
    }

    step(): Constructor<Step> {
        return PhoneVerificationStep;
    }

    async navigateToNextStep(): Promise<void> {
        await this.nextPage();
    }

    shouldShowConsentCheckboxes(): boolean {
        return (!this.isLoanAssociated() && this.userNavigator.isUserLoggedIn()) || this.showOtp;
    }

    protected errorMessages(): object {
        return {};
    }

    protected async getAndSetConsentStates(): Promise<void> {
        if (!this.userUtil.isUserRegistered()) {
            this.borrowedAmountDeclarationCheck = false;
            this.consentForEquifaxCheck = false;
            this.termsAndConditionsCheck = false;
            return;
        }

        if (!this.isLoanAssociated()) {
            this.borrowedAmountDeclarationCheck = false;
            this.consentForEquifaxCheck = false;
            this.termsAndConditionsCheck = false;
            return;
        }

        const loanApplication = await this.loanApplicationInteractor.get();
        const userId = await this.userInteractor.getUserId();

        const consentsForApplicationAndUser = await this.consentService.getConsentForLoanApplicationAndGivenBy(loanApplication.id, userId);
        this.userConsents = consentsForApplicationAndUser;

        this.termsAndConditionsCheck = consentsForApplicationAndUser.some(consent => consent.type === ConsentType.TERMS_AND_CONDITIONS);
        this.consentForEquifaxCheck = consentsForApplicationAndUser.some(consent => consent.type === ConsentType.EQUIFAX_CHECK);
        this.borrowedAmountDeclarationCheck = consentsForApplicationAndUser.some(consent => consent.type === ConsentType.BORROWER_EXPOSURE_ACROSS_P2P_PLATFORMS);
    }

    private async createLoanApplicationAndSaveConsents(): Promise<LoanApplication> {
        let loanApplication = await this.createLoanApplicationRequest();
        if (!loanApplication.id) {
            loanApplication = await this.loanApplicationInteractor.create(loanApplication);
        } else {
            loanApplication = await this.loanApplicationInteractor.update(loanApplication);
        }
        await this.loanApplicationInteractor.saveApplicationToStorage(loanApplication);
        await this.storageService.saveItem(Keys.BORROWER, 'true');
        await this.createConsentsForApplication(loanApplication.id);
        return loanApplication;
    }

    private areTermsChecked(formdata) {
        return formdata.termsAndConditionsCheck && formdata.consentForEquifaxCheck && formdata.borrowedAmountDeclarationCheck;
    }

    private async createLoanApplicationRequest() {
        const application = await this.loanApplicationInteractor.get();
        const userId = await this.userInteractor.getUserId();
        const creditReportId = this.storageService.getItem(Keys.CREDIT_REPORT_ID);
        const creditOptionId = this.storageService.getItem(Keys.CREDIT_OPTION_ID);
        const state = this.storageService.getObject<{ eligibilityCheckForm: SharedEligibilityCheckForm }>(Keys.EXTRA_OPTIONS_STATE);
        let advanceEmiPlan;
        if (state && state.eligibilityCheckForm && state.eligibilityCheckForm.advanceEmiOption) {
            const eligibilityCheckForm = state.eligibilityCheckForm;
            advanceEmiPlan = new AdvanceEmiPlan(eligibilityCheckForm.requestedAmount, eligibilityCheckForm.advanceEmiOption);
        }
        const loanApplicationPayload: LoanApplication = new LoanApplication(application.amount, application.reason, userId, Number(application.tenure), application.partnerId, advanceEmiPlan);
        if (creditReportId && creditOptionId) {
            loanApplicationPayload.creditReportId = creditReportId;
            loanApplicationPayload.creditOptionId = creditOptionId;
        }
        return loanApplicationPayload;
    }

    private isLoanAssociated(): boolean {
        // TODO : Should get loan application from interactor
        const loanApplication: LoanApplication = JSON.parse(this.storageService.getItem(Keys.LOAN_APPLICATION));
        return !!loanApplication.id;
    }

    private async createConsentsForApplication(loanApplicationId: string): Promise<void> {
        await this.consentService.saveConsentAudit(new ConsentAudit(ConsentType.TERMS_AND_CONDITIONS, loanApplicationId));
        await this.consentService.saveConsentAudit(new ConsentAudit(ConsentType.EQUIFAX_CHECK, loanApplicationId));
        await this.consentService.saveConsentAudit(new ConsentAudit(ConsentType.BORROWER_EXPOSURE_ACROSS_P2P_PLATFORMS, loanApplicationId));
    }

    shouldDisableConsentCheckboxes(): boolean {
        return !(this.userUtil.isUserLoggedIn() || this.showOtp);
    }

}
